/* eslint-disable camelcase */
import React, { Component } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import {
  Button,
  FormInput,
  FormInputText,
  ContentSectionBlock,
  FormInputCheckbox,
  ButtonContainer
} from 'camino-react'

import Modal from 'Components/Modal'
import { cloudhelpPatch, cloudhelpPost } from 'Utilities/CloudHelp'

class TimesheetAdminFormModal extends Component {
  constructor (props) {
    super()
    const { workItem } = props

    this.state = {
      fields: { ...workItem },
      errors: [],
      savingStatus: 'Save'
    }
  }

  submit = () => {
    const {
      modalType,
      itemType,
      workItem,
      closeModal,
      paths
    } = this.props
    const { fields } = this.state
    const { name } = fields
    let data
    if (itemType === 'workTypes') {
      const { on_site } = fields
      // eslint-disable-next-line camelcase
      data = { ...workItem, name: name || '', on_site: on_site || false }
    } else {
      data = { ...workItem, name: name || '' }
    }

    const { updatePath } = workItem || {}
    const pathOptions = {
      edit: updatePath || '',
      new: paths[itemType]
    }
    this.setState({
      savingStatus: 'Saving ...'
    })

    const methodOptions = { edit: cloudhelpPatch, new: cloudhelpPost }
    const cloudhelpMethod = methodOptions[modalType]

    cloudhelpMethod(pathOptions[modalType], data)
      .then((response) => {
        closeModal()
        window.location.href = response.data.redirect_url
      })
      .catch((error) => {
        this.setState({
          errors: error.response.data.errors,
          savingStatus: 'Save'
        })
      })
  }

  handleFieldValue = (key, value) => {
    this.setState((prevState) => {
      const { fields } = prevState

      const newFields = Object.assign({}, fields, { [key]: value })

      return { fields: newFields }
    })
  }

  render () {
    const {
      modalType,
      itemType,
      closeModal
    } = this.props

    const {
      handleFieldValue,
      submit
    } = this

    const {
      fields,
      errors,
      savingStatus
    } = this.state
    // eslint-disable-next-line camelcase
    const { name, on_site } = fields

    const styledItemType = _.lowerCase(itemType)

    return (
      <Modal
        showModal={modalType}
        title={modalType === 'edit' ? `Edit ${styledItemType}` : `Create new ${styledItemType}`}
        removeModal={() => { closeModal() }}
      >
        <FormInput label="Name">
          <FormInputText
            value={name}
            onValue={value => (handleFieldValue('name', value))}
            errors={errors}
          />
        </FormInput>
        { (styledItemType === "work types") && (
          <FormInput label="On-Site">
            <FormInputCheckbox
              id="on-site-work-type"
              // eslint-disable-next-line camelcase
              value={on_site}
              rows={5}
              onValue={value => handleFieldValue('on_site', value)}
            />
          </FormInput>
        )}
        <ButtonContainer center spaced>
          <Button onClick={() => closeModal()} outline>
            Cancel
          </Button>
          <Button onClick={() => submit()}>
            {savingStatus}
          </Button>
        </ButtonContainer>
      </Modal>
    )
  }
}

TimesheetAdminFormModal.propTypes = {
  modalType: PropTypes.string,
  itemType: PropTypes.string,
  workItem: PropTypes.object,
  closeModal: PropTypes.func.isRequired,
  paths: PropTypes.object.isRequired
}

TimesheetAdminFormModal.defaultProps = {
  modalType: '',
  itemType: '',
  workItem: {}
}

export default TimesheetAdminFormModal
